import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { IConfirmation } from 'core/types';
import { QuoteOrderPricingType } from 'quotes/enums';
import { IQuotePart } from 'quotes/types';
import { Color } from 'theme/enums';

interface IProps {
  activeParts: IQuotePart[];
  onConfirm: (orderPricingType?: QuoteOrderPricingType) => void;
  onCancel: () => void;
}

export const OrderVendorQuoteConfirmation = ({ activeParts = [], onConfirm, onCancel }: IProps) => {
  const [confirmation, setConfirmation] = useState<IConfirmation | null>(null);

  const { t } = useTranslation();

  useEffect(() => {
    const baseConfirmation = {
      title: t('titleWarning'),
      message: t('messageConfirmOrder'),
      confirmBtnColor: Color.SUCCESS,
      onConfirm,
      onCancel,
    };

    const quotePartsWithoutPricing = activeParts.filter(
      (part: IQuotePart) => part.partArr?.id && !part.price
    );

    let quotePartsWithoutPricingConfirmation: IConfirmation | null = null;

    if (quotePartsWithoutPricing.length > 0) {
      quotePartsWithoutPricingConfirmation = {
        ...baseConfirmation,
        message: t('messageConfirmOrderLinesWithoutPricing', {
          linesWithoutPricing: quotePartsWithoutPricing
            .map((part: IQuotePart) => part.line)
            .join(', '),
        }),
        onConfirm: null,
        confirmationActions: [
          {
            label: t('buttonLabelConfirmOrderOmitPricing'),
            onClick: () => onConfirm(QuoteOrderPricingType.OMIT),
            type: QuoteOrderPricingType.OMIT,
          },
          {
            label: t('buttonLabelConfirmOrderIncludePricing'),
            onClick: () => onConfirm(QuoteOrderPricingType.INCLUDE),
            type: QuoteOrderPricingType.INCLUDE,
          },
        ],
      };
    }

    if (quotePartsWithoutPricingConfirmation) {
      setConfirmation(quotePartsWithoutPricingConfirmation);

      return;
    }

    setConfirmation(baseConfirmation);
  }, [activeParts, onCancel, onConfirm, t]);

  return <Confirmation isOpen={true} {...confirmation} />;
};
